import * as RadixPopover from "@radix-ui/react-popover";
import { type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { BfrsPortalScope } from "@/components/ui/providers/BfrsProvider";
import { floatingCollisionPadding, floatingLayerClassName, popoverContentCollisionClassName } from "../overlayPositioning";

export type PopoverProps = {
  trigger: ReactNode;
  children: ReactNode;
  align?: "start" | "center" | "end";
  className?: string;
};

export function Popover({ trigger, children, align = "center", className }: PopoverProps) {
  return (
    <RadixPopover.Root>
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <BfrsPortalScope>
          <RadixPopover.Content
            align={align}
            sideOffset={8}
            collisionPadding={floatingCollisionPadding}
            className={cn(
              floatingLayerClassName,
              "bfrs-w-80 bfrs-rounded-xl bfrs-border bfrs-border-border bfrs-bg-surface-card bfrs-p-4 bfrs-shadow-elevated bfrs-outline-none bfrs-animate-content-in",
              popoverContentCollisionClassName,
              className
            )}
          >
            {children}
            <RadixPopover.Arrow className="bfrs-fill-surface-card" />
          </RadixPopover.Content>
        </BfrsPortalScope>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
